var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMessageEnrichment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#915CFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 25.2083L21.3333 23.2917V11.7917C21.3333 10.7174 22.1757 9.875 23.25 9.875C24.3243 9.875 25.1667 10.7174 25.1667 11.7917V23.2917L23.25 25.2083ZM23.25 25.2083H10.7917C10.2833 25.2083 9.79582 25.0064 9.43638 24.647C9.07693 24.2875 8.875 23.8 8.875 23.2917C8.875 22.7833 9.07693 22.2958 9.43638 21.9364C9.79582 21.5769 10.2833 21.375 10.7917 21.375H14.625C15.1333 21.375 15.6208 21.1731 15.9803 20.8136C16.3397 20.4542 16.5417 19.9667 16.5417 19.4583C16.5417 18.95 16.3397 18.4625 15.9803 18.103C15.6208 17.7436 15.1333 17.5417 14.625 17.5417H11.75M21.3333 13.7083H25.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageEnrichment);
export default __webpack_public_path__ + "static/media/icon-message-enrichment.f99418b93f1b26870f509130bb73c483.svg";
export { ForwardRef as ReactComponent };